export default "__VITE_ASSET__C8xCW9_k__"